<template>
  <div class="pageInner">
    <header>
      <div>
        <label>Total Original</label>
        <h4>{{ formatMoney(debitos.valorTotalOriginal) }}</h4>
      </div>
      <div class="totalFinalBox">
        <label>Total Final</label>
        <h4>{{ formatMoney(valorFinalCobrado) }}</h4>
      </div>
    </header>
    <section v-if="wStep != 1">
      <div v-if="formaSelecionada || formaEscolhidaResumo" class="highlight-card">
        <p class="nome-forma">
          {{ formaSelecionada?.nome || formaEscolhidaResumo?.nome }} por
        </p>
        <h2>
          {{ formatMoney(
            formaSelecionada?.valorTotalAtualizado ??
            formaSelecionada?.valorFinalCobrado ??
            formaEscolhidaResumo?.valor ?? 0
          ) }}
        </h2>
      </div>
    </section>
    <div class="formas">
      <div class="user-ui">
        <h4 v-if="wStep == 1">Formas de Pagamento</h4>
        <h4 v-if="wStep == 2">Selecione como deseja pagar</h4>
        <h4 v-if="wStep == 3">Customize sua forma de pagamento</h4>
      </div>
      <ul v-if="wStep == 1">
        <template v-if="!mostrarTodas">
          <li v-if="bestValue">
            <header>
              <h4>Melhor Valor</h4>
              <label class="round-check">
                <fa v-if="selected === bestValue.idNegocieJaFormaPagamento" :icon="['far', 'check']" class="ic"/>
                <input type="radio" name="forma" v-model="selected" :value="bestValue.idNegocieJaFormaPagamento" />
              </label>
            </header>
            <div>
              <label>{{ bestValue.nome }} por</label>
              <h3>{{ formatMoney(bestValue.valorTotalAtualizado) }}</h3>
            </div>
          </li>
          <li v-if="bestCondition">
            <header>
              <h4>Melhor Condição</h4>
              <label class="round-check">
                <fa v-if="selected === bestCondition.idNegocieJaFormaPagamento" :icon="['far', 'check']" class="ic"/>
                <input type="radio" name="forma" v-model="selected" :value="bestCondition.idNegocieJaFormaPagamento" />
              </label>
            </header>
            <div>
              <label>{{ bestCondition.nome }} por</label>
              <h3>{{ formatMoney(bestCondition.valorTotalAtualizado) }}</h3>
            </div>
            <footer>
              <strong>Você pode ajustar essa forma de pagamento!</strong>
            </footer>
          </li>
          <li v-if="temMuitasFormas">
            <a href="#" class="todasFormas" @click.prevent="abrirTodas">
              <h5>Ver todas formas disponíveis</h5>
              <fa :icon="['fa', 'credit-card']" />
            </a>
          </li>
        </template>
        <template v-else>
          <li v-for="forma in todasFormasOrdenadas" :key="forma.idNegocieJaFormaPagamento">
            <header>
              <label class="forma-nome">{{ forma.nome }} por</label>
              <label class="round-check">
                <fa v-if="selected === forma.idNegocieJaFormaPagamento" :icon="['far', 'check']" class="ic"/>
                <input type="radio" name="forma" v-model="selected" :value="forma.idNegocieJaFormaPagamento" />
              </label>
            </header>
            <div>
              <h3>{{ formatMoney(forma.valorTotalAtualizado) }}</h3>
            </div>
          </li>
          <li>
            <a href="#" class="todasFormas" @click.prevent="fecharTodas">
              <h5>Voltar</h5>
              <fa :icon="['fal', 'arrow-left-long']" />
            </a>
          </li>
        </template>
      </ul>
      <ul v-if="wStep == 2" class="step-2">
        <li>
          <!-- Switches: Forma de Entrada -->
          <div class="modal-escolha" v-if="formasDisponiveisEntrada.length > 0">
            <header>
              <h4>Entrada no</h4>
            </header>
            <div class="field-selecao">
              <switch-control
                v-for="forma in formasDisponiveisEntrada"
                :key="forma"
                :labelOn="forma.charAt(0).toUpperCase() + forma.slice(1)"
                :labelOff="forma.charAt(0).toUpperCase() + forma.slice(1)"
                :checked="entradaTipo === forma"
                :disabled="formasDisponiveisEntrada.length === 1"
                @update:checked="val => handleEntradaToggle(forma, val)"
              />
            </div>
          </div>

          <!-- Switches: Forma de Parcelamento -->
          <div class="modal-escolha" v-if="formasDisponiveisParcelamento.length > 0">
            <header>
              <h4>Parcelas no:</h4>
            </header>
            <div class="field-selecao">
              <switch-control
                v-for="forma in formasDisponiveisParcelamento"
                :key="forma"
                :labelOn="forma.charAt(0).toUpperCase() + forma.slice(1)"
                :labelOff="forma.charAt(0).toUpperCase() + forma.slice(1)"
                :checked="parcelaTipo === forma"
                :disabled="formasParcelamentoValidas.length === 1 || !parcelamentoHabilitado(forma)"
                @update:checked="val => handleParcelaToggle(forma, val)"
              />
            </div>
          </div>

        </li>
      </ul>
      <ul v-if="wStep == 3" class="step-3">
        <!-- CARD: ENTRADA -->
        <li v-if="mostrarCampoEntrada" class="card-bloco card-bloco-footer">
          <div class="card-body">
            <div class="field">
              <div class="text-info">
                <h4>Percentual</h4>
                <small>De {{ minEntrada }}% até {{ maxEntrada }}%</small>
              </div>
              <div class="field-control">
                <div class="chip-wrap">
                  <span class="chip-sufix">%</span>
                </div>
                <div class="input-circle">
                  <input
                    type="number"
                    v-model.number="entradaPercent"
                    :min="minEntrada"
                    :max="maxEntrada"
                    placeholder="35"
                  >
                </div>
              </div>
            </div>

            <div class="field" v-if="entradaParcelada">
              <div class="text-info">
                <h4>Parcelas Ent.</h4>
                <small>Até {{ parcelasEntrada }}x</small>
              </div>
              <div class="field-control">
                <div class="chip-wrap">
                  <span class="chip-sufix">x</span>
                </div>
                <div class="input-circle">
                  <input
                    type="number"
                    v-model.number="qtdParcelasEntrada"
                    :min="1"
                    :max="parcelasEntrada"
                    placeholder="1"
                  >
                </div>
              </div>
            </div>
          </div>

          <footer class="card-foot">
            <strong>{{ formatMoney(valorEntrada) }}</strong>
            <strong v-if="entradaParcelada && Number(qtdParcelasEntrada) > 1">
              <br>{{ qtdParcelasEntrada }}x de {{ formatMoney(valorParcelaEntrada) }}
            </strong>
          </footer>
        </li>

        <!-- CARD: PARCELAMENTO  -->
        <li v-if="mostrarCampoParcelamento" class="card-bloco card-bloco-footer">
          <div class="card-body">
            <div class="field">
              <div class="text-info">
                <h4>Parcelas</h4>
                <small>De 1 a {{ maxParcelas }}x</small>
              </div>
              <div class="field-control">
                <div class="chip-wrap">
                  <span class="chip-sufix">x</span>
                </div>
                <div class="input-circle">
                  <input
                    type="number"
                    v-model.number="parcelas"
                    :min="1"
                    :max="maxParcelas"
                    placeholder="6"
                  >
                </div>
              </div>
            </div>
          </div>

          <footer class="card-foot">
            <strong>{{ parcelas }}x de {{ formatMoney(valorParcela) }}</strong>
          </footer>
        </li>

        <li v-if="!mostrarCampoEntrada && !mostrarCampoParcelamento" class="card-bloco">
          <div class="card-body">
            <p class="text-muted">Essa forma de pagamento não possui condições ajustáveis!</p>
          </div>
        </li>
      </ul>

    </div>
    <footer>
      <button-nav @onClick="wStep == 3 ? validarStep3EContinuar() : next()">
        Continuar
      </button-nav>
    </footer>
  </div>
</template>

<script>
import { formatMoney } from '@/services/utils.service.js'
import ButtonNav from '@/components/financeiro/negocieja/app/navigation/ButtonNav.vue'

export default {
  components: {
    ButtonNav
  },
  props: {
    session: {
      type: String
    },
    steps: {
      type: Array
    },
    debitos: {
      type: Object
    },
    idProposta: {
      type: [String, Number]
    }
  },
  data () {
    return {
      wizard: [1,2,3],
      wStep: 1,
      bestValue: null,
      bestCondition: null,
      selected: null,
      proposta: null,
      entradaPercent: '',
      entradaTipo: '',
      parcelaTipo: '',
      parcelas: '',
      qtdParcelasEntrada: '',
      mostrarTodas: false
    }
  },
  mounted () {
    const firstStep = this.wizard && this.wizard.length ? String(this.wizard[0]) : '1'
    if (this.wStep !== firstStep) this.$emit('update:step', firstStep)
    
    this.$store.dispatch('negocieja/get').then(response => {
      console.log("negocieja:", response)
      this.proposta = response
      // console.log("user:", this.currentUser)
      this.processPaymentMethods()
    })
  },
  watch: {
    wStep ( value ) {
      if ( value == 3 ) {
        if (this.mostrarCampoEntrada && !this.entradaPercent) {
          this.entradaPercent = this.minEntrada
        }
        if (this.mostrarCampoParcelamento && !this.parcelas) {
          this.parcelas = this.maxParcelas
        }
        if (this.entradaParcelada && !this.qtdParcelasEntrada) {
          this.qtdParcelasEntrada = this.parcelasEntrada
        }
      }
    },
    entradaTipo () {
      if (!this.parcelaTipo || !this.parcelamentoHabilitado(this.parcelaTipo)) {
        const primeiraHabilitada = this.formasDisponiveisParcelamento.find(f => this.parcelamentoHabilitado(f))
        this.parcelaTipo = primeiraHabilitada || ''
      }
    },
  },
computed: {
  matrizCompatibilidade () {
  return {
    cartao: ['boleto'],
    pix: ['boleto'],
    boleto: ['boleto'],
    none: ['pix','boleto','cartao']
  }
  },
  formasParcelamentoValidas () {
    const base = this.formasDisponiveisParcelamento
    if (!this.temEntrada) return base.filter(f => this.matrizCompatibilidade.none.includes(f))
    if (!this.entradaTipo) return []
    const permitidas = this.matrizCompatibilidade[this.entradaTipo] || []
    return base.filter(f => permitidas.includes(f))
  },

  mostrarCampoEntrada () {
    const ent = this.formaSelecionada?.entrada
    const minPercentuais = [
      ent?.percentualMinimoCartao,
      ent?.percentualMinimoBoleto,
      ent?.percentualMinimoPix
    ]
    return !!(ent?.cartao || minPercentuais.some(p => p && p > 0))
  },
  mostrarCampoParcelamento () {
    const p = this.formaSelecionada?.parcelas || {}
    const maxes = [
      p?.cartao?.parcelas,
      p?.boleto,
      p?.pix,
      p?.maximoParcelasCartao,
      p?.maximoParcelasBoleto,
      p?.maximoParcelasPix
    ]
    return maxes.some(v => parseInt(v) > 1)
  },
  valorFinalCobrado () {
    const f = this.formaSelecionada
    if (f) {
      const v = Number(f.valorFinalCobrado ?? f.valorTotalAtualizado ?? 0)
      return isNaN(v) ? 0 : v
    }

    const local = this.carregarFormaEscolhidaLocal()
    if (local) {
      const v = Number(local.valorFinalCobrado ?? local.valorTotalAtualizado ?? 0)
      return isNaN(v) ? 0 : v
    }

    return Number(this.debitos?.valorFinalCobrado ?? this.totalFinalCorrigido ?? 0)
  },
  temEntrada () {
    return this.formasDisponiveisEntrada.length > 0
  },
  entradaParcelada () {
    const ent = this.formaSelecionada?.entrada?.cartao
    return !!(ent?.parcelasEntrada && parseInt(ent.parcelasEntrada) > 1)
  },
  parcelasEntrada () {
    if (!this.entradaTipo || !this.formaSelecionada?.entrada) return 1
    const tipo = this.entradaTipo.toLowerCase()
    const key = `maximoParcelas${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`
    return parseInt(this.formaSelecionada.entrada[key]) || 1
  },
  temRangeEntrada () {
    return this.minEntrada !== null && this.maxEntrada !== null
  },
  minEntrada () {
    if (!this.entradaTipo || !this.formaSelecionada?.entrada) return 0
    const tipo = this.entradaTipo.toLowerCase()
    const key = `percentualMinimo${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`
    return this.formaSelecionada.entrada[key] || 0
  },
  maxEntrada () {
    return 99
  },
  maxParcelas () {
    if (!this.parcelaTipo || !this.formaSelecionada?.parcelas) return 1
    const tipo = this.parcelaTipo.toLowerCase()
    const key = `maximoParcelas${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`
    return parseInt(this.formaSelecionada.parcelas[key]) || 1
  },
  totalDoApp () {
    const f = this.formaSelecionada || this.formaEscolhidaResumo
    return Number(
      f?.valorTotalAtualizado ??
      f?.valorFinalCobrado ??
      this.debitos?.valorFinalCobrado ??
      0
    )
  },
  valorEntrada () {
    return this.temEntrada ? (this.entradaPercent / 100) * this.totalDoApp : 0
  },
  valorParcelaEntrada () {
    if (!this.temEntrada || !this.entradaParcelada) return this.valorEntrada
    return this.qtdParcelasEntrada ? this.valorEntrada / this.qtdParcelasEntrada : 0
  },
  valorParcela () {
    const base = this.temEntrada ? (this.totalDoApp - this.valorEntrada) : this.totalDoApp
    return this.parcelas ? base / this.parcelas : 0
  },
  totalFinalCorrigido () {
    // const store = JSON.parse(localStorage.getItem('negociacaoDados'))
    const store = this.proposta
    if ( store ) {
      const arr = store?.valores_corrigidos || []
      return arr.reduce((s, i) => s + Number(i.valor_corrigido), 0)
    } else {
      return 0
    }
    
  },
  formaSelecionada () {
    if (!this.debitos?.formasPagamento?.length) return null
    return this.debitos.formasPagamento.find(f => f.idNegocieJaFormaPagamento === this.selected) ?? null
  },
  formasDisponiveisEntrada () {
    const entrada = this.formaSelecionada?.entrada || {}
    const formas = []
    if (entrada.pix && (entrada.percentualMinimoPix || entrada.maximoParcelasPix)) formas.push('pix')
    if (entrada.boleto && (entrada.percentualMinimoBoleto || entrada.maximoParcelasBoleto)) formas.push('boleto')
    if (entrada.cartao && (entrada.percentualMinimoCartao || entrada.maximoParcelasCartao)) formas.push('cartao')
    return formas
  },
  formasDisponiveisParcelamento () {
    const p = this.formaSelecionada?.parcelas || {}
    const formas = []
    if (p.pix) formas.push('pix')
    if (p.boleto && (p.maximoParcelasBoleto || 0) > 0) formas.push('boleto')
    if (p.cartao && (p.maximoParcelasCartao || 0) > 0) formas.push('cartao')
    return formas
  },
  temMuitasFormas () {
    return Array.isArray(this.debitos?.formasPagamento) && this.debitos.formasPagamento.length > 2
  },
  todasFormasOrdenadas () {
    if (!Array.isArray(this.debitos?.formasPagamento)) return []
    return [...this.debitos.formasPagamento].sort((a, b) => {
      const va = Number(a.valorTotalAtualizado ?? a.valorFinalCobrado ?? 0)
      const vb = Number(b.valorTotalAtualizado ?? b.valorFinalCobrado ?? 0)
      return va - vb
    })
  },
  formaEscolhidaResumo () {
    const f = this.formaSelecionada || this.carregarFormaEscolhidaLocal()
    if (!f) return null
  
    const valor = Number(f.valorTotalAtualizado ?? f.valorFinalCobrado ?? 0)
    return {
      nome: f.nome,
      valor: isNaN(valor) ? 0 : valor,
      linha: this.montarLinhaResumo(f)
    }
  },
  },
  methods: {
    abrirTodas () {
      this.mostrarTodas = true
    },
    fecharTodas () {
      this.mostrarTodas = false
    },
    parcelamentoHabilitado (forma) {
      if (!this.temEntrada) return true
      if (!this.entradaTipo) return false
      const permitidas = this.matrizCompatibilidade[this.entradaTipo] || []
      return permitidas.includes(forma)
    },
    validarStep3EContinuar () {
      if (this.mostrarCampoEntrada) {
        if (this.entradaPercent < this.minEntrada || this.entradaPercent > this.maxEntrada) {
          window.toaster?.emit?.('open', {
            style: 'error',
            message: `A entrada deve estar entre ${this.minEntrada}% e ${this.maxEntrada}%`,
            floater: true
          })
          return
        }
        if (this.entradaParcelada) {
          if (this.qtdParcelasEntrada < 1 || this.qtdParcelasEntrada > this.parcelasEntrada) {
            window.toaster?.emit?.('open', {
              style: 'error',
              message: `A entrada pode ser parcelada em até ${this.parcelasEntrada}x`,
              floater: true
            })
            return
          }
        }
      }

      if (this.mostrarCampoParcelamento) {
        if (this.parcelas < 1 || this.parcelas > this.maxParcelas) {
          window.toaster?.emit?.('open', {
            style: 'error',
            message: `A quantidade de parcelas deve estar entre 1 e ${this.maxParcelas}`,
            floater: true
          })
          return
        }
      }

      this.$store.dispatch('negocieja/salvarParametrosPagamento', {
        entradaTipo: this.entradaTipo,
        parcelaTipo: this.parcelaTipo,
        entradaPercent: this.entradaPercent,
        qtdParcelasEntrada: this.qtdParcelasEntrada,
        parcelas: this.parcelas
      })

      this.next()
    },
    formatMoney (value) {
      return formatMoney(value)
    },
    syncEntrada (list) {
      if (!Array.isArray(list) || list.length === 0) {
        this.entradaTipo = ''
        return
      }
      if (!list.includes(this.entradaTipo)) {
        this.entradaTipo = list[0]
      }
    },
    syncParcela (list) {
      if (!Array.isArray(list) || list.length === 0) {
        this.parcelaTipo = ''
        return
      }
      if (!list.includes(this.parcelaTipo)) {
        this.parcelaTipo = list[0]
      }
    },
    handleEntradaToggle (forma, checked) {
      if (checked) {
        this.entradaTipo = forma
        // garante um parcelamento válido para a nova entrada
        if (!this.parcelaTipo || !this.parcelamentoHabilitado(this.parcelaTipo)) {
          const primeiraHabilitada = this.formasDisponiveisParcelamento.find(f => this.parcelamentoHabilitado(f))
          this.parcelaTipo = primeiraHabilitada || ''
        }
      } else if (this.entradaTipo === forma) {
        this.entradaTipo = this.formasDisponiveisEntrada[0] || ''
        if (!this.parcelaTipo || !this.parcelamentoHabilitado(this.parcelaTipo)) {
          const primeiraHabilitada = this.formasDisponiveisParcelamento.find(f => this.parcelamentoHabilitado(f))
          this.parcelaTipo = primeiraHabilitada || ''
        }
      }
    },
    handleParcelaToggle (forma, checked) {
      if (checked) {
        this.parcelaTipo = forma
      } else if (this.parcelaTipo === forma) {
        this.parcelaTipo = this.formasDisponiveisParcelamento[0] || ''
      }
    },
    montarLinhaResumo (f) {
      const e = f?.entrada
      const p = f?.parcelas

      const pick = src => {
        if (!src) return null
        if (src.cartao) return src.cartao
        if (src.boleto) return src.boleto
        if (src.pix) return src.pix
        return null
      }

      const eSel = pick(e)
      const pSel = pick(p)
      const partes = []

      if (eSel?.parcelasEntrada && eSel?.valorEntrada) {
        partes.push(`${eSel.parcelasEntrada}x de ${this.formatMoney(eSel.valorEntrada)}`)
      }
      if (pSel?.parcelas && pSel?.valorParcela) {
        partes.push(`${pSel.parcelas}x de ${this.formatMoney(pSel.valorParcela)}`)
      }

      if (partes.length) return `Entrada: ${partes[0]}${partes[1] ? ' + ' + partes[1] : ''}`
      return f?.descricao || ''
    },
    persistirFormaEscolhida () {
      const f = this.formaSelecionada
      if (!f) return

      const payload = {
        idNegocieJaFormaPagamento: f.idNegocieJaFormaPagamento,
        nome: f.nome,
        valorTotalAtualizado: f.valorTotalAtualizado ?? f.valorFinalCobrado ?? 0,
        entrada: f.entrada || null,
        parcelas: f.parcelas || null
      }

      localStorage.setItem('negocieja_forma_escolhida', JSON.stringify(payload))
    },
    carregarFormaEscolhidaLocal () {
      try {
        const raw = localStorage.getItem('negocieja_forma_escolhida')
        return raw ? JSON.parse(raw) : null
      } catch {
        return null
      }
    },
    processPaymentMethods () {
      const paymentMethods = this.debitos.formasPagamento
      const lowestValor = paymentMethods.reduce((min, item) =>
        item.valorTotalAtualizado < min.valorTotalAtualizado ? item : min
      )

      const highestParcelas = paymentMethods.reduce((maxItem, item) => {
        const currentParcelas = this.getParcelasCount(item)
        const maxParcelas = this.getParcelasCount(maxItem)
        return currentParcelas > maxParcelas ? item : maxItem
      })

      this.bestValue = lowestValor
      this.bestCondition = highestParcelas
      this.selected = this.bestValue.idNegocieJaFormaPagamento

      this.$nextTick(() => {
        this.syncEntrada(this.formasDisponiveisEntrada)
        this.syncParcela(this.formasParcelamentoValidas)
      })
    },
    next () {
      const idx = this.wizard.indexOf(this.wStep)
      console.log("idx:", idx)
      console.log("this.wStep:", this.wStep)

      if (idx > -1 && idx < this.wizard.length - 1) {
        const nextStep = this.wizard[idx + 1]
        console.log("nextStep:", nextStep)
        console.log("formaSelecionada:", this.formaSelecionada)

        if ( this.wStep == 1 && this.formaSelecionada ) {
          const f = this.formaSelecionada
          console.log("f:", f)
          this.proposta.formaEscolhida = {
            idNegocieJaFormaPagamento: f.idNegocieJaFormaPagamento,
            nome: f.nome,
            valorTotalAtualizado: Number(f.valorTotalAtualizado ?? f.valorFinalCobrado ?? 0)
          }
          this.$store.dispatch('negocieja/salvarFormaEscolhida', {
            idNegocieJaFormaPagamento: f.idNegocieJaFormaPagamento,
            nome: f.nome,
            valorTotalAtualizado: Number(f.valorTotalAtualizado ?? f.valorFinalCobrado ?? 0)
          })

          this.persistirFormaEscolhida()
        }

        this.wStep = nextStep
        
        if ( nextStep == 2 ) {
          this.$nextTick(() => {
            this.syncEntrada(this.formasDisponiveisEntrada)
            this.syncParcela(this.formasDisponiveisParcelamento)
          })
        }
        return
      }
      this.$emit('onNext', { selected: this.selected })
    },
    getParcelasCount (item) {
      const p = item.parcelas
      const values = []

      if (p.cartao && typeof p.cartao === 'object') values.push(Number(p.cartao.parcelas))
      else if (typeof p.cartao === 'number') values.push(p.cartao)
      if (typeof p.boleto === 'number') values.push(p.boleto)
      else if (typeof p.boleto === 'object' && p.boleto?.parcelas) values.push(Number(p.boleto.parcelas))
      if (typeof p.pix === 'number') values.push(p.pix)
      else if (typeof p.pix === 'object' && p.pix?.parcelas) values.push(Number(p.pix.parcelas))
      return Math.max(...values.filter(v => !isNaN(v)))
    }
  }
}
</script>

<style lang="scss" scoped>

  .forma-nome {
    width: 80%;
  } 

  .chip-wrap {
    position: absolute;
    right: 0; top: 5px;
    transform: translateX(50%);

    .chip-sufix {
      background-color: $azul;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      border-radius: 50%;
      height: 2rem;
      width: 2rem;
      color: $color-secondary;
      font-weight: 700;
      font-size: $font-size;
    }
  }
  

  .pageInner {
    color: $preto-2;
    z-index: 5;
    display: flex; flex-direction: column;
    overflow: hidden;
    height: 100%;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    
    >section {
      padding: $hmg_mid $hmg_large;

      @media screen and ( max-height: 689px ) {
        padding: 0 $hmg_mid $hmg_mid;
      }
    }

    .highlight-card {
      background-color: $azul-escuro;
      color: $azul;
      // margin: $mg;
      padding: $hmg-mid;
      border-radius: $border-radius;

      h2 {
        margin: 0;
      }

      p {
        color: $color-secondary;
        margin-bottom: $hmg-mini;
      }
    }

    .step-3 {
      padding: 0;
      margin: 0;

      .card-bloco {
        list-style: none;
        background-color: $color-secondary;
        border-radius: $border-radius;
        padding: $hmg_mid;
        gap: 1rem;
        position: relative;

        &-footer {
          padding: 0;
        }

        .card-head {
          position: absolute;
          right: 10px; 
          top: 10px;
          padding: 0;
        }

        .card-body {
          padding: $hmg_mid;
          gap: $hmg-mid;
          display: flex;
          flex-direction: column;
        }

        .card-foot {
          background-color: $azul-escuro;
          color: $branco;
          font-weight: 700;
          padding: $hmg_small;
          border-bottom-left-radius: $border-radius;
          border-bottom-right-radius: $border-radius;
        }

        p {
          margin: 0;
        }
      }

      .field {
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        text-align: end;
        gap: $mg-small;

        .text-info {
          display: flex;
          flex-direction: column;
          text-align: start;
          font-size: 18px;
          padding: 0 !important;
          color: $preto !important;

          h4 {
            margin: 0;
          }
        }

        .field-control {
          display: flex;
          align-items: center;
          position: relative;

          .input-circle {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 5rem;
            height: 5rem;
            border-radius: 100%;
            background-color: $cinza-claro;
            color: $cinza-escuro;
            // margin-top: $mg;

            input {
              width: 5rem;
              border-radius: 100%;
              border: none;
              background-color: $cinza-claro;
              color: $azul-escuro;
              font-size: 2rem;
              text-align: center;
              &:focus { outline: none }
            }
          }
        }
      }

      .param-footer {
        display: flex;
        justify-content: flex-end;
        margin-top: $hmg_small;
      }
    }

    .step-2 { 
        li {
          list-style: none;
          padding: 0; margin-bottom: $mg_mini;
          border-radius: $border-radius;
          background-color: $branco !important;
          color: $preto !important;

          .field-selecao {
            width: 100%;
            display: flex;
            justify-content: space-around;
            height: $mg;
          }
          

          header {
            padding: $hmg_mid $hmg_mid 0 $hmg_mid;
            display: flex; 
            align-items: flex-start;
            justify-content: space-between;
            text-align: center;
          }

          footer {
            text-align: center;
            color: $azul-escuro;
            padding: $mg-mini;
            background-color: $azul;
            border-bottom-left-radius: $border-radius;
            border-bottom-right-radius: $border-radius;
          }

          >div {
            padding: 0 $hmg_mid $hmg_mid $hmg_mid;

            h3 {
              font-size: 28px;
              color: $color-success;
              margin: 0; padding: 0;
            }
          }
      }
    }

    >div {
      
      flex-shrink: 0;
      height: 100%;
      flex: 1;
      max-height: auto;

      >h4 {
        max-width: 540px;
        z-index: 3;
        flex-shrink: 0; 
        text-align: center;
        padding: 0 $hmg_large;

        @media screen and ( max-height: 689px ) {
          padding: 0 $hmg_mid;
        }
      }
    }

    >header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: $hmg_large $hmg_large 0 ;

      @media screen and ( max-height: 689px ) {
        padding: $hmg_mid;
      }

      >div {
        label {
          margin: 0;
        }
        h4 {
          margin: 0; padding: 0;
        }
        &:last-child {
          text-align: right;
          border-radius: $border-radius;
          background-color: $color-secondary;
          padding: $hmg_small;
        }
      }
    }

    .formas {
      padding: $hmg_large;

      @media screen and ( max-height: 689px ) {
        padding: 0 $hmg_mid 0;
      }

      .user-ui {
        display: flex;
        align-items: center;
        gap: $mg-mini;

        h4 {
          margin: 0; padding: 0;
        }
      }

      > h4 { padding: 0; margin: 0;}

      ul {
        padding: 0; margin: $hmg_mid 0 0 ;

        @media screen and ( max-height: 689px ) {
        margin: $mg_mini 0 0 ;
      }

        li {
          list-style: none;
          padding: 0; margin-bottom: $mg_mini;
          border-radius: $border-radius;
          background-color: $azul-escuro;
          color: $color-secondary;

          .todasFormas {
            display: flex;
            justify-content: space-between;
            align-items: center;
            text-align: center;
            padding: $hmg-small;
            background-color: $branco !important;
            color: $preto;
            border-radius: $border-radius;
            font-size: 16px;

            h5 {
              margin: 0; padding: 0;
            }
          }
          

          header {
            padding: $hmg_mid $hmg_mid 0 $hmg_mid;
            display: flex; align-items: flex-start;
            justify-content: space-between;
          }

          footer {
            text-align: center;
            color: $azul-escuro;
            padding: $mg-mini;
            background-color: $azul;
            border-bottom-left-radius: $border-radius;
            border-bottom-right-radius: $border-radius;
          }

          >div {
            padding: 0 $hmg_mid $hmg_mid $hmg_mid;

            h3 {
              font-size: 28px;
              color: $color-success;
              margin: 0; padding: 0;
            }
          }
        }
      }
    }
    
    >footer {
      padding: $hmg_large;
      position: relative;

       @media screen and ( max-height: 689px ) {
        padding: $hmg_mid;
      }

      a {
        position: relative;
        z-index: 101;
      }
    }
  }
</style>